<template>
    <HeroSection :icon="eventApp.icon" :featureName="eventApp.name">
        <template #title>{{ eventApp.description }}</template>
        <template #description>
            <div>Absolutely packed with functionality to make your event run smoothly, and engage attendees like never
                before.</div>
            <div class="mt-4">Backed by easy to use, secure and powerful content management tools.</div>

        </template>
        <template #content>
            <div class="w-full relative h-[500px]">
                <div class="absolute top-0 left-0 w-1/2 h-full" >
                    <DeviceWrapper deviceType="phone" :width="80" :z="0" :x="0" :y="12" :rotateOnScroll="true" :imageSrc="eventAppImage" />
                </div>

                <div class="absolute top-0 right-12 w-1/2 h-full" >
                    <DeviceWrapper deviceType="phone" :width="80" :z="0" :x="0" :y="-16" :rotateOnScroll="true" :imageSrc="eventAppImage2" />
                </div>

                <div v-reveal class="absolute bottom-0 right-0 w-64 h-64 ">
                    <img :src="megaphone" alt="Badge" class="w-full h-full object-contain" />
                </div>
            </div>
        </template>
    </HeroSection>

    <OneApp />
    <PackedWithFeatures title="Absolutely packed with easy to use, beautifully designed features" subheader="Packed with Features" />

    <WorksWith title="Event Apps" :integrations="integrations" />
    <Tips title="Event Apps" :tips="tips" />
    <Cta />

</template>

<script setup>
import HeroSection from '@/components/HeroSection.vue'
import QrCodeIcon from '@heroicons/vue/24/outline/QrCodeIcon'
import WorksWith from '@/components/Blocks/WorksWith.vue'
import Tips from '@/components/Blocks/Tips.vue'
import DeviceWrapper from '@/components/DeviceWrapper.vue'
import AppFeatures from '@/components/Layouts/AppFeatures.vue'
import Cta from '@/components/Blocks/Cta.vue'
import PackedWithFeatures from '@/components/Features/EventApp/PackedWithFeatures.vue'
import OneApp from '@/components/Features/EventApp/OneApp.vue'

//Images
import eventAppImage from '@/images/screenshots/app/theme-1/menu.png'
import eventAppImage2 from '@/images/screenshots/app/theme-1/menu.png'

import megaphone from '@/images/megaphone.svg'

import { getFeaturesByIds } from '../../router/features'

const integrations = getFeaturesByIds(['leadcapture', 'attendancetracking', 'eventapp'])

const eventApp = getFeaturesByIds(['eventapp'])[0];

const tips = [
    'Use Profile Filters to create dynamic menus and navigation bars for your attendees. Only present the information that is relevant to them.',
    'Look for creative ways to add Sponsored messages to the event app. Always link back to the sponsor\'s app page.',
    'Use the Activity Feed to engage with your attendees. This is a great way to drive engagement and keep your attendees informed and excited.',
]

const steps = [
    {
        icon: QrCodeIcon,
        title: 'Connect & Authorize Devices',
        description: 'Connect and authorize kiosks or print servers in seconds.'
    },
    {
        icon: QrCodeIcon,
        title: 'Scan QRs or Search for Attendees',
        description: 'Scan QR codes or search for attendees by name or email.'
    },
    {
        icon: QrCodeIcon,
        title: 'Create Profiles or Update Attendee Details',
        description: 'Create profiles for attendees or update their details in real time.'
    },
    {
        icon: QrCodeIcon,
        title: 'Print Badges',
        description: 'Print badges to any connected device in your Event network.'
    },
    {
        icon: QrCodeIcon,
        title: 'View Statistics',
        description: 'View statistics for your event in real time.'
    },
    {
        icon: QrCodeIcon,
        title: 'Access Additional Staff Tools',
        description: 'While you are there, send access details, reset passwords, update details, and more.'
    }

]
</script>